import { render, staticRenderFns } from "./Subheader.vue?vue&type=template&id=01d576a0&scoped=true"
import script from "./Subheader.vue?vue&type=script&lang=js"
export * from "./Subheader.vue?vue&type=script&lang=js"
import style0 from "./Subheader.vue?vue&type=style&index=0&id=01d576a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d576a0",
  null
  
)

export default component.exports